const determineStoreLinks = (): string => {
  let forgotPasswordLinkUrl;
  const hostname = window && window.location && window.location.hostname;
  const host = hostname.toLowerCase();
  const prodRegex = /^reporthub.emlpayments.net$/;
  const prodMatch = host.match(prodRegex);
  const qaRegex = /(alpha|bravo|charlie|delta|foxtrot-[0-9]{1,2})/;
  const qaMatch = host.match(qaRegex);
  const testRegex = /(xtest|uat)/;
  const testMatch = host.match(testRegex);

  if (prodMatch) {
    //prod
    forgotPasswordLinkUrl =
      "https://storelink.storefinancial.net/Modules/SecurityModule/Default.aspx?action=ForgotPassword";
  } else if (qaMatch) {
    //we are in one of the four QA envirnoments, concatenate appropriate host
    forgotPasswordLinkUrl =
      "https://storelink-" +
      qaMatch[0] +
      ".storefinancialdev.net/Modules/SecurityModule/Default.aspx?action=ForgotPassword";
  } else if (testMatch) {
    //we are in xtest test environment
    forgotPasswordLinkUrl = "https://storelink." +
    testMatch[0] +
    ".storefinancial.net/Modules/SecurityModule/Default.aspx?action=ForgotPassword";
  } else {
    // local
    forgotPasswordLinkUrl =  "http://local.storefinancialdev.net/StoreLink/Modules/SecurityModule/Default.aspx?action=ForgotPassword";
  }

  return forgotPasswordLinkUrl;
};

export const STORELINK_FORGOT_PASSWORD_PATH = determineStoreLinks();
